/*
  SAVED SEARCHES + WATCH LIST — Club Partner
  ---------------------------------------------------------------------------
  "Save this search" (next to the search bar on collection pages) and the
  heart on each club (product cards + product pages).

  Saved searches and watched clubs live in the "Club Partner Alerts" app,
  reached through Shopify's app proxy at /apps/cp/... Shopify adds the
  signed-in shopper's id to each request and signs it, so nobody can save
  into someone else's account. Once a day that app emails new matches,
  price drops and sold notices (trade app, lib/alerts.mjs).

  Not signed in? Tapping Save or a heart remembers what they wanted, sends
  them to sign in, and finishes the job when they come back.

  custom-filters.js calls window.CPAlerts.saveSearch() and asks
  window.CPAlerts.isWatched() while drawing cards; everything else is here.
*/
(function () {
  'use strict';
  if (window.CPAlerts) return;

  var me = document.currentScript;
  var signedIn = !!(me && me.getAttribute('data-signed-in'));
  var accountUrl = (me && me.getAttribute('data-account-url')) || '/account';
  var PROXY = '/apps/cp/';
  var PENDING = 'cp_alerts_pending';
  var CACHE = 'cp_alerts_state';
  var watched = {};          // product id -> true
  var stateReady = null;

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.4 4.5 6.9 4.5c2.1 0 3.6 1.2 5.1 3 1.5-1.8 3-3 5.1-3 3.5 0 5.5 3.5 4.2 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';
  var BOOKMARK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.5 3.5h11a1 1 0 0 1 1 1v16l-6.5-4.2-6.5 4.2v-16a1 1 0 0 1 1-1z"/></svg>';

  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  function readJSON(kind, key) { try { return JSON.parse(store(kind).getItem(key) || 'null'); } catch (e) { return null; } }
  function writeJSON(kind, key, v) { try { if (v == null) store(kind).removeItem(key); else store(kind).setItem(key, JSON.stringify(v)); } catch (e) { /* private mode */ } }

  function api(path, body) {
    return fetch(PROXY + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function remember(state) {
    watched = {};
    (state.watches || []).forEach(function (w) { watched[String(w.productId)] = true; });
    writeJSON('sessionStorage', CACHE, { at: Date.now(), watches: Object.keys(watched) });
    paintHearts();
  }

  // What this shopper is watching, so hearts can show filled. Signed-in only;
  // kept for two minutes per tab so browsing doesn't ask on every page.
  function loadState() {
    if (!signedIn) return Promise.resolve(null);
    if (stateReady) return stateReady;
    var c = readJSON('sessionStorage', CACHE);
    if (c && Date.now() - c.at < 120000) {
      watched = {};
      c.watches.forEach(function (id) { watched[id] = true; });
      stateReady = Promise.resolve(c);
      paintHearts();
      return stateReady;
    }
    stateReady = api('state').then(function (s) {
      if (s && s.signedIn === false) { signedIn = false; return null; }
      remember(s);
      return s;
    }).catch(function () { return null; });
    return stateReady;
  }

  // ---- Sign in, then carry on ---------------------------------------------
  function goSignIn(pending, returnTo) {
    writeJSON('localStorage', PENDING, Object.assign({ at: Date.now() }, pending));
    var back = returnTo || (location.pathname + location.search);
    location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(back);
  }
  function finishPending() {
    var p = readJSON('localStorage', PENDING);
    if (!p) return;
    writeJSON('localStorage', PENDING, null);
    if (!signedIn || Date.now() - p.at > 30 * 60000) return;
    if (p.type === 'search') saveSearch(p.data);
    if (p.type === 'watch') setWatch(p.data, true);
  }

  // ---- Little message at the bottom of the screen -------------------------
  var toastEl = null, toastTimer = null;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cp-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 5200);
  }
  var manage = ' <a href="' + accountUrl.replace(/"/g, '&quot;') + '">Manage</a>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // ---- Save this search ----------------------------------------------------
  // data: { url: '/collections/all-clubs?club_type=Driver&...', collectionTitle }
  function saveSearch(data, button) {
    if (!signedIn) { goSignIn({ type: 'search', data: data }, data.url); return; }
    if (button) { button.disabled = true; button.classList.add('is-busy'); }
    api('search', data).then(function (r) {
      if (r.signedIn === false) { signedIn = false; goSignIn({ type: 'search', data: data }, data.url); return; }
      if (!r.ok) { toast(esc(r.error || 'That didn’t save. Please try again.')); return; }
      if (button) button.classList.add('is-saved');
      toast((r.existed ? 'Already saved: ' : 'Saved: ') + '<b>' + esc(r.search.label) + '</b>. We’ll email you new matches once a day.' + manage);
      remember(r);
    }).catch(function () {
      toast('That didn’t save. Please try again.');
    }).then(function () {
      if (button) { button.disabled = false; button.classList.remove('is-busy'); }
    });
  }

  // ---- Hearts ----------------------------------------------------------------
  function heartData(btn) {
    return {
      productId: btn.getAttribute('data-watch'),
      title: btn.getAttribute('data-title') || '',
      url: btn.getAttribute('data-url') || '',
      image: btn.getAttribute('data-image') || '',
      price: Number(btn.getAttribute('data-price')) || 0
    };
  }
  function paintHearts() {
    var all = document.querySelectorAll('[data-watch]');
    for (var i = 0; i < all.length; i++) {
      var on = !!watched[all[i].getAttribute('data-watch')];
      all[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = all[i].querySelector('[data-watch-label]');
      if (label) label.textContent = on ? 'Watching' : 'Watch this club';
    }
  }
  function setWatch(data, on) {
    if (!signedIn) { goSignIn({ type: 'watch', data: data }); return; }
    var id = String(data.productId);
    if (on) watched[id] = true; else delete watched[id];
    paintHearts();                                   // show it straight away
    api('watch', Object.assign({}, data, { on: on })).then(function (r) {
      if (r.signedIn === false) { signedIn = false; goSignIn({ type: 'watch', data: data }); return; }
      if (!r.ok) { toast(esc(r.error || 'That didn’t save. Please try again.')); }
      else toast(on ? 'Added to your watch list. We’ll email you if the price drops or it sells.' + manage : 'Removed from your watch list.');
      remember(r);
    }).catch(function () {
      if (on) delete watched[id]; else watched[id] = true;
      paintHearts();
      toast('That didn’t save. Please try again.');
    });
  }

  // The card is one big link, so the heart must stop the click from opening
  // the product. Capture phase, so it runs before anything else on the card.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-watch]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    setWatch(heartData(btn), btn.getAttribute('aria-pressed') !== 'true');
  }, true);

  // ---- Product page: a "Watch this club" button under Add to cart ------------
  function productButton() {
    var el = document.getElementById('cp-alerts-product');
    if (!el) return;
    var p;
    try { p = JSON.parse(el.textContent); } catch (e) { return; }
    var anchor = document.querySelector('.product-form__buttons') || document.querySelector('product-form') || document.querySelector('.product__title');
    if (!anchor || document.querySelector('.cp-watch-btn')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cp-watch-btn';
    b.setAttribute('data-watch', String(p.id));
    b.setAttribute('data-title', p.title || '');
    b.setAttribute('data-url', p.url || '');
    b.setAttribute('data-image', p.image || '');
    b.setAttribute('data-price', String(p.price || 0));
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML = HEART + '<span data-watch-label>Watch this club</span>';
    anchor.parentNode.insertBefore(b, anchor.nextSibling);
    paintHearts();
  }

  window.CPAlerts = {
    get signedIn() { return signedIn; },
    saveSearch: saveSearch,
    isWatched: function (id) { return !!watched[String(id)]; },
    heartSvg: HEART,
    bookmarkSvg: BOOKMARK,
    paint: paintHearts
  };

  function boot() {
    productButton();
    loadState().then(finishPending);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
